import React from 'react';

const NewsSourceLink = ({ source }) => {
  if (!source?.url) return null;
  return (
    <a
      className="news-source-link"
      href={source.url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      title={source.original_title || undefined}
    >
      {source.source_name}
      {source.lang === 'en' ? ' (영문)' : ''} 원문 보기
      <span aria-hidden="true"> ↗</span>
    </a>
  );
};

export default NewsSourceLink;
